import _orderBy from 'lodash/orderBy'
import {
  deleteTimeTrackingCategory,
  getDailyRoundCheckpointsCategories,
  getTimeTrackingCategories,
  patchTimeTrackingCategory,
  saveTimeTrackingCategory } from 'frontend/communications/apiClient'
import { sortAlphabetically } from 'frontcore/utils/helpers/formatters'

const stateObj = {
  categories: [],
  timeTrackingCategories: [],
}

const getters = {
  getDailyRoundCheckpointsCategories (state) {
    return state.categories
  },
  getActiveDailyRoundCheckpointsCategories (state) {
    return state.categories.filter(category => category.enabled).sort(
      sortAlphabetically('name')
    )
  },
  getActiveDailyRoundCheckpointsCategoriesAndException: (state) => (exception) => {
    return state.categories.filter(category => {
      return category.enabled || category.id === exception
    }).sort(
      sortAlphabetically('name')
    )
  },
  getDRCategoryById: (state) => (id) => {
    return state.categories.find(category => category.id === id)
  },
  getTimeTrackingCategories (state) {
    return state.timeTrackingCategories
  },
  getTimeTrackingCategoryById: (state) => (id) => {
    return state.timeTrackingCategories.find(category => category.id === id)
  },
}

const mutations = {
  setDailyRoundCheckpointsCategories (state, categories) {
    state.categories = _orderBy(categories, 'id')
  },
  setTimeTrackingCategories (state, categories) {
    state.timeTrackingCategories = categories
  },
  createTimeTrackingCategory (state, category) {
    state.timeTrackingCategories.push(category)
  },
  updateDailyRoundCategory (state, value) {
    const categoryIndex = state.categories.findIndex(category => category.id === value.id)
    if (categoryIndex !== -1) {
      state.categories.splice(categoryIndex, 1, value)
    }
  },
  updateTimeTrackingCategory (state, category) {
    const index = state.timeTrackingCategories.findIndex(d => d.id === category.id)
    const auxCategories = { ...state.timeTrackingCategories[index], ...category }
    state.timeTrackingCategories.splice(index, 1, auxCategories)
  },
  removeTimeTrackingCategory (state, id) {
    state.timeTrackingCategories = state.timeTrackingCategories
      .filter(category => category.id !== id)
  },
}

const actions = {
  async fetchDailyRoundCheckpointsCategories ({ commit }) {
    const categories = await getDailyRoundCheckpointsCategories()
    commit('setDailyRoundCheckpointsCategories', categories)
    return categories
  },
  async fetchTimeTrackingCategories ({ commit }) {
    const categories = await getTimeTrackingCategories()
    commit('setTimeTrackingCategories', categories)
    return categories
  },
  async createTimeTrackingCategory ({ commit }, payload) {
    const category = await saveTimeTrackingCategory(payload)
    commit('createTimeTrackingCategory', category)
    return category
  },
  async updateTimeTrackingCategory ({ commit }, payload) {
    const id = payload.id
    delete payload.id
    const category = await patchTimeTrackingCategory(id, payload)
    commit('updateTimeTrackingCategory', category)
    return category
  },
  async removeTimeTrackingCategory ({ commit }, id) {
    const category = await deleteTimeTrackingCategory(id)
    commit('removeTimeTrackingCategory', id)
    return category
  },
}

export default {
  actions,
  getters,
  mutations,
  state: stateObj,
}
